/**
 * Table Select Modal Component - Using new Modal component
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalTitle,
} from '../../components/ui/modal';
import { Button } from '../../components/ui/button';
import { Table2 } from 'lucide-react';
import { cn } from '../../lib/utils';

export function TableSelectModal({
  open,
  onOpenChange,
  tables,
  selectedTable,
  onSelect,
}) {
  const { t } = useTranslation();

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <ModalContent size="default">
        <ModalHeader>
          <ModalTitle className="flex items-center gap-2">
            <Table2 className="h-5 w-5" />
            {t('pdv.selectTable')}
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          <div className="grid grid-cols-4 gap-3">
            <Button
              variant={!selectedTable ? 'default' : 'outline'}
              className="h-16"
              onClick={() => onSelect(null)}
            >
              Balcão
            </Button>
            {tables.map(table => (
              <Button
                key={table.id}
                variant={selectedTable?.id === table.id ? 'default' : 'outline'}
                className={cn(
                  'h-16 flex-col',
                  table.status === 'ocupada' && 'border-orange-500',
                  table.status === 'reservada' && 'border-blue-500'
                )}
                onClick={() => onSelect(table)}
                data-testid={`table-${table.id}`}
              >
                <span className="font-bold">{table.number}</span>
                <span className="text-xs opacity-70">{table.status}</span>
              </Button>
            ))}
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default TableSelectModal;
